import type { SVGProps } from 'react';

const SvgMoneyBilling = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 15c0-1.84-1.35-3.4-3.62-4.19-1.69-.68-2.37-1.04-2.37-1.94 0-1.06.86-1.87 2-1.87.57 0 1.11.24 1.49.67a.998.998 0 1 0 1.49-1.33c-.53-.59-1.23-.99-1.98-1.19V4.01c0-.55-.45-1-1-1s-1 .45-1 1v1.13c-1.74.42-3 1.9-3 3.73 0 2.34 2.01 3.15 3.63 3.79h.03s.01 0 .02.01c.54.19 2.32.9 2.32 2.32 0 1.1-.9 2-2 2s-2-.9-2-2c0-.55-.45-1-1-1s-1 .45-1 1c0 1.86 1.28 3.41 3 3.86v1.14c0 .55.45 1 1 1s1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86z"
    />
  </svg>
);
export default SvgMoneyBilling;
